import { CaretLeftIcon, Cross2Icon } from '@radix-ui/react-icons'
import { MoreHorizontal } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { Link, useParams } from 'react-router-dom'
import { ADD_COUPLEUR, DELETE_COUPLEUR } from '../../Utils/constant'
import { Port } from '../../components/Icons/Port'
import { Loader } from '../../components/Widget/Loader'
import { SubmitButton } from '../../components/Widget/SubmitButton'
import { deleteOne, store } from '../../services/service'
import { usePBOStore } from '../../store/pboStore/listPboStore'

export const PboCoupleur = () => {
    const { id, nom } = useParams()
    const coupleurByPBO = usePBOStore()
    const [selectItem, setSelectItem] = useState(null)
    const {
        register,
        handleSubmit, reset,
        formState: { errors },
    } = useForm()
    const [isSubmit, setIsSubmit] = useState(false);
    const [error, setError] = useState("")

    const submit = (data) => {
        setIsSubmit(true)
        store(ADD_COUPLEUR, 'application/json', { ...data, pboId: id }).then((res) => {
            if (res.status === 200) {
                coupleurByPBO.getCoupleurByPBO(id)
                document.getElementById('close').click()
                toast.success('Enregistrement effectuté')
                setIsSubmit(false)
                reset()
            }
        }).catch((err) => {
            setIsSubmit(false)
            setError(err?.response?.data?.donnee)
        })
    }

    useEffect(() => {
        coupleurByPBO.getCoupleurByPBO(id)
    }, [])

    // const more = (page) => {
    //     listPorts.getData(`/${id}?page=${page - 1}&param=&size=8&status=`)
    // }

    return (
        <div className="">
            <div className="lg:flex gap-8 items-center">
                <button className='btn bg-white btn-sm' onClick={() => { window.history.back() }}><CaretLeftIcon /></button>
                <h3 class="font-mtn text-3xl font-bold">
                    Les coupleurs du PBO
                </h3>

            </div>
            <div className="rounded-md px-2 py-4 mt-3">
                <div className="mt-3 lg:flex items-center gap-2">
                    {/* <input
                        onChange={(e) => {
                            listPorts.getData(`/${id}?page=0&param=${e.target.value}&size=8&status=`)
                        }}
                        type="text" placeholder="Rechercher element..." className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
                    />
                    <select onChange={(e) => {
                        listPorts.getData(`/${id}?page=0&param=&size=8&status=${e.target.value}`)
                    }} className="select" >
                        <option disabled>
                            Status Pbos
                        </option>
                        <option value='LIBRE' selected>Libre</option>
                        <option value='RESERVER' >Reserver</option>
                        <option value='CONNECTER'>Connecter</option>
                        <option value='DEFECTUEUX' >Defectueux</option>
                    </select> */}
                    <div className='ml-auto flex items-center gap-2'>
                        <dialog id="add_pbo" className="modal rounded-none">
                            <div className="modal-box w-10/12 max-w-xl">
                                <div className="modal-action">
                                    <h1 className='font-mtn mr-auto text-2xl font-bold'>
                                        Ajouter un coupleur
                                    </h1>
                                    <form method="dialog">
                                        <button id='close' className="btn btn-sm"><Cross2Icon /></button>
                                    </form>
                                </div>
                                <div>
                                    <p className='text-sm text-red-600'>{error}</p>
                                    <form onSubmit={handleSubmit(submit)} className="w-full  mx-auto mt-6">
                                        <div className="items-center gap-x-3">
                                            <label className="form-control">
                                                <div className="label -mb-1">
                                                    <span className="label-text font-medium">
                                                        Designation du coupleur <span className="text-red-500">*</span>
                                                    </span>
                                                </div>
                                                <input
                                                    {...register('designation', { required: true })}
                                                    type="text"
                                                    placeholder="designation du brin"
                                                    className="input input-bordered w-full h-10 text-sm "
                                                />
                                            </label>
                                        </div>
                                        <SubmitButton isSubmit={isSubmit} label={"Enregistrer"} />
                                    </form>
                                </div>
                            </div>
                        </dialog>

                        <button
                            onClick={() => {
                                document.getElementById('add_pbo').showModal()
                            }}
                            className="btn btn-sm h-10 hover:bg-[#ffcb05] bg-[#ffcb05] "
                        >
                            Ajouter un brin
                        </button>
                    </div>
                </div>
                <div className='grid md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-5 gap-2 my-8'>
                    {
                        coupleurByPBO?.coupleurs?.length === 0 ? 'Aucune donnée' :
                            coupleurByPBO?.coupleurs?.length !== 0 && !coupleurByPBO?.loading ? (
                                coupleurByPBO?.coupleurs?.map((item) => (
                                    <div key={item.id} className='relative flex gap-1 items-center cursor-pointer text-black shadow-sm border bg-white  rounded text-xs'>
                                        <div className="dropdown dropdown-end absolute right-2 top-2">
                                            <div
                                                tabIndex={0}
                                                role="button"
                                                className="w-4 h-4 rounded-full flex items-center bg-gray-50"
                                            >
                                                <MoreHorizontal size={20} />
                                            </div>
                                            <ul
                                                tabIndex={0}
                                                className="mt-1 dropdown-content z-[1] menu p-2 border shadow bg-base-100 rounded-lg w-44"
                                            >
                                                <Link to={`${item.id}/Liste-port}`}

                                                    className="bg-white text-black hover:bg-gray-300 font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                                                >
                                                    Voir les port
                                                </Link>
                                                <dialog id={`edit${item.id}`} className="modal rounded-none">
                                                    <div className="modal-box w-10/12 max-w-xl">
                                                        <div className="modal-action">
                                                            <h1 className='font-mtn mr-auto text-2xl font-bold'>
                                                                Modifier un coupleur
                                                            </h1>
                                                            <form method="dialog">
                                                                <button id='close_edit' className="btn btn-sm"><Cross2Icon /></button>
                                                            </form>
                                                        </div>
                                                        <div>
                                                            <p className='text-sm text-red-600'>{error}</p>
                                                            {/* <UpdatePort portId={item?.id} defaultValue={item?.status} /> */}
                                                        </div>
                                                    </div>
                                                </dialog>

                                                <button
                                                    onClick={() => {
                                                        setSelectItem(item)
                                                        document.getElementById('delete').showModal()
                                                    }
                                                    }
                                                    className="bg-white hover:bg-red-600 text-black hover:text-white font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                                                >
                                                    Supprimer
                                                </button>
                                                <dialog id="delete" className="modal">
                                                    <div className="modal-box max-w-md rounded-lg">
                                                        <h3 className="font-extrabold text-xl text-red-600 ">
                                                            Attention
                                                        </h3>
                                                        <p className="pt-2 text-black font-medium">
                                                            Voulez vous vraiment effectuer cette action ?
                                                        </p>
                                                        <div className="modal-action">
                                                            <form
                                                                method="dialog"
                                                                className="w-full flex items-center justify-end gap-x-4" >
                                                                <button className="bg-gray-100 text-gray-600 w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                                                                    Annuler
                                                                </button>
                                                                <button onClick={() => {
                                                                    deleteOne(DELETE_COUPLEUR, selectItem.id).then(() => {
                                                                        toast.success('Element suprimé')
                                                                        coupleurByPBO.getCoupleurByPBO(id)
                                                                    }).catch((err) => {

                                                                    })
                                                                }} className="bg-red-600 text-white w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                                                                    Supprimer
                                                                </button>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </dialog>
                                            </ul>
                                        </div>
                                        <div className='bg-amber-400 w-10 h-10 rounded m-1 flex items-center justify-center'>
                                            <Port />
                                        </div>
                                        <div className=''>
                                            <p className='font-bold truncate w-36'>Coupleur ({item?.numero})</p>
                                        </div>
                                    </div>
                                ))
                            ) : <Loader />
                    }

                </div>


            </div >
        </div >
    )
}
